<!-- Filter - Search - Form  -->
<div *ngIf="userPermissions?.job_status?.view" class="data-action-form">
  <div class="row justify-content-between align-items-end">
    <div class="col-12 col-sm-12 col-md-12 col-lg-9 col-xl-7">
      <div class="row mx-n2 align-items-end">
        <div class="col-12 col-sm-6 col-md col-lg-3 col-xl px-2">
          <div class="form-group">
            <label>Working Status</label>
            <select
              class="form-control select2MultipleWithCheck"
              #working_status
              id="working_status"
              (change)="searchInTable(working_status.value, 'working_status')"
              name="working_status"
              data-placeholder="Working Status"
              multiple="multiple">
              <option
                *ngFor="let item of workingStatusData"
                value="{{ item.id }}"
                [selected]="checkIsSelected(item.id, 'working_status')">
                {{ item.name }}
              </option>
            </select>
            <div style="width: 0 !important; height: 0 !important; overflow: hidden !important">
              <input
                type="text"
                class="working_status multiCheckVal"
                [(ngModel)]="searchInfo.working_status"
                #working_status1
                (blur)="searchInTable(working_status1.value, 'working_status')" />
            </div>
          </div>
        </div>
        <div class="col-12 col-sm-6 col-md col-lg-3 col-xl px-2">
          <div class="form-group">
            <label>Project Assistant</label>
            <select
              class="form-control select2"
              #projectAssistant
              id="assistant_id"
              [(ngModel)]="searchInfo.assistant_id"
              name="assistant_id"
              (change)="searchInTable(projectAssistant.value, 'assistant_id')">
              <option selected="selected" value="">Assistant</option>
              <option *ngFor="let item of ProjectAssistantData" value="{{ item.id }}">
                {{
                  item.employee_alias != null && item.employee_alias != '' && item.employee_alias != undefined
                    ? item.employee_alias
                    : item.first_name + ' ' + item.last_name
                }}
              </option>
            </select>
            <div style="width: 0 !important; height: 0 !important; overflow: hidden !important">
              <input
                type="text"
                [(ngModel)]="searchInfo.assistant_id"
                (blur)="searchInTable(projectAssistant.value, 'assistant_id')" />
            </div>
          </div>
        </div>
        <div class="col-12 col-sm-6 col-md col-lg-3 col-xl px-2">
          <div class="form-group">
            <label>Job Status</label>
            <select
              class="form-control select2MultipleWithCheck"
              id="status"
              name="status"
              data-placeholder="Job Status"
              multiple="multiple">
              <option value="1" [selected]="checkIsSelected('1', 'status')">Started</option>
              <option value="2,3,4" [selected]="checkIsSelected('2,3,4', 'status')">Active</option>
              <option value="5" [selected]="checkIsSelected('5', 'status')">Closed</option>
              <option value="0" [selected]="checkIsSelected('0', 'status')">Deleted</option>
            </select>
            <div style="width: 0 !important; height: 0 !important; overflow: hidden !important">
              <input
                type="text"
                [(ngModel)]="searchInfo.status"
                class="multiCheckVal"
                #jobStatus
                (blur)="searchInTable(jobStatus.value, 'status')" />
            </div>
          </div>
        </div>
        <div class="col-12 col-sm-12 col-md col-lg-3 col-xl px-2">
          <div class="form-group">
            <a href="javascript:;" data-toggle="modal" data-target="#filter" class="btn btn-outline-primary more-filter"
              >More Filters <span class="dot">.</span> 3</a
            >
          </div>
        </div>
      </div>
    </div>
    <div class="col-12 col-sm-12 col-md-12 col-lg-3 col-xl-4">
      <div class="row mx-n2 align-items-end">
        <div class="col-12 col-sm-8 col-md-8 col-lg-7 px-2">
          <div class="search-box">
            <div class="form-group">
              <input
                type="text"
                name=""
                placeholder="Search"
                class="form-control fild"
                [(ngModel)]="searchInfo.search"
                #search
                (keyup)="searchInTable(search.value, 'search')" />
              <button type="submit" class="search"><i class="fas fa-search"></i></button>
            </div>
          </div>
        </div>
        <div class="col-12 col-sm-4 col-md-4 col-lg-5 px-2">
          <div class="form-group">
            <a
              href="javascript:;"
              data-toggle="modal"
              data-target="#create-job"
              class="btn btn-block btn-primary"
              (click)="generateCSV()"
              >Export</a
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- Filter - Search - Form  End-->
<div *ngIf="userPermissions?.job_status?.view" class="filter-options">
  <ul class="list-unstyled d-flex">
    <li><a href="javascript:;" (click)="saveFilter()">Save Filters</a></li>
    <li class="divider">|</li>
    <li><a href="javascript:;" (click)="clearFilter()">Clear Filters</a></li>
  </ul>
</div>
<div *ngIf="userPermissions?.job_status?.view" class="invoicing-table">
  <div class="table-responsive">
    <table class="table jobs-invoice-data-table" id="invoiceTable"></table>
  </div>
</div>

<!-- Filter Modal -->
<div class="modal fade" id="filter" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content pb-0">
      <form action="#" id="FiltersForm">
        <div class="modal-header">
          <h5 class="modal-title">More Filters</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true"><i class="fal fa-times"></i></span>
          </button>
        </div>
        <div class="modal-body">
          <div class="form-group">
            <label>Customer</label>
            <select
              class="form-control select2"
              #arCustomer
              [(ngModel)]="searchInfo.contact_ar_customer_name_id"
              name="contact_ar_customer_name_id"
              id="arCustomer">
              <option value="" selected="">Customer</option>
              <option *ngFor="let item of arCustomerData" value="{{ item.id }}">{{ item.name }}</option>
            </select>
          </div>
          <div class="form-group">
            <label>Billing Type</label>
            <select
              class="form-control select2"
              #billingType
              id="billingType"
              [(ngModel)]="searchInfo.contact_type_of_billing"
              name="contact_type_of_billing">
              <option value="" selected="">Billing Type</option>
              <option value="1">Quick Bill</option>
              <option value="2">Contract</option>
              <option value="3">AIA</option>
            </select>
          </div>
          <div class="form-group">
            <label>Project Manager</label>
            <select
              class="form-control select2"
              #projectManager
              id="project_manager_id"
              [(ngModel)]="searchInfo.project_manager_id"
              name="project_manager_id">
              <option selected="selected" value="">Project Manager</option>
              <option *ngFor="let item of projectManagerData" value="{{ item.id }}">
                {{
                  item.employee_alias != null && item.employee_alias != '' && item.employee_alias != undefined
                    ? item.employee_alias
                    : item.first_name + ' ' + item.last_name
                }}
              </option>
            </select>
          </div>
        </div>
        <div class="modal-footer justify-content-center border-0">
          <button type="button" class="btn btn-outline-primary width-fix" data-dismiss="modal" #closeFilterModel>
            Cancel
          </button>
          <button
            type="submit"
            class="btn btn-primary width-fix"
            (click)="
              searchInTable(
                arCustomer.value,
                'contact_ar_customer_name_id',
                billingType.value,
                'contact_type_of_billing',
                projectManager.value,
                'project_manager_id'
              )
            ">
            Apply Filters
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
<!-- Filter Modal End-->

<div style="width: 0 !important; height: 0 !important; overflow: hidden !important">
  <input type="text" value="" class="chatJobId" #chatJobId (blur)="getPotentialJobsWorkingComments(chatJobId.value)" />
</div>

<div style="width: 0 !important; height: 0 !important; overflow: hidden !important">
  <input
    type="text"
    value=""
    class="newInvoiceCustomerSortData"
    #newInvoiceData
    (blur)="sortInvoiceCustomerData(newInvoiceData.value)" />
</div>

<div class="hiddenInput">
  <button (click)="loadMoreData()" class="invoiceLoadMoreData"></button>
</div>
<!-- Chat Modal -->
<div class="modal fade" id="chat-modal" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog modal-lg">
    <div class="modal-content pb-0">
      <form action="#" id="FiltersForm">
        <div class="modal-header bg-color" *ngIf="jobDetail">
          <h5 class="modal-title">
            {{ jobDetail.customer_name }} {{ jobDetail.number }} -
            {{ getDepartmentFromList(jobDetail.departments_list) }}
          </h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true"><i class="fal fa-times"></i></span>
          </button>
        </div>
        <div class="modal-body p-0">
          <!-- <div *ngIf="!messagesLoaded" class="col-sm-12 text-center">
                        <div class="spinner-border m-5" role="status">
                            <span class="sr-only">Loading...</span>
                        </div>
                    </div> -->
          <div class="chat">
            <div class="chat-history scrollbar" id="chatBlock">
              <ul>
                <li
                  class="{{ chatData.user_id == userId ? 'my-msg' : 'other-msg' }}"
                  *ngFor="let chatData of potentialJobsWorkingCommentsData">
                  <div class="msg-data">{{ chatData.user_name }}, {{ getFormattedDate(chatData.created_date) }}</div>
                  <div class="msg">
                    {{ chatData.comment }}
                  </div>
                </li>
              </ul>
              <div *ngIf="!messagesLoaded" class="col-sm-12 text-center">
                <div class="spinner-border m-5" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
              </div>
            </div>
            <div class="msg-text">
              <div class="inner d-flex justify-content-between align-items-center">
                <div class="type-fild">
                  <input
                    type="text"
                    [(ngModel)]="user_message"
                    name="user_message"
                    class="form-control"
                    placeholder="Type a message here..." />
                </div>
                <div class="right-option">
                  <a href="javascript:;" class="emoji"><i class="far fa-smile"></i></a>
                  <button type="submit" class="send" (click)="sendMessage()"><i class="fas fa-paper-plane"></i></button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
<!-- Chat Modal End-->
